import XLSX from 'xlsx';
import moment from 'moment';

const styleCenter = { // 样式不支持,需要用到xlsx的pro版本,要花几百$,但代码还是写着了,据说可以用xlsx-style代替,但是很久没更新了,就作罢
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  }
};

function exportSubDeviceXlsx({subDeviceList}) {
  let sheetData = {
    A1: { v: '地址', s: styleCenter },
    B1: { v: '组件名称', s: styleCenter },
    C1: { v: '组件型号', s: styleCenter },
    D1: { v: '组件编号', s: styleCenter },
    E1: { v: '生产日期', s: styleCenter },
    F1: { v: '软件版本', s: styleCenter },
    G1: { v: '组件串号', s: styleCenter },
    H1: { v: '状态', s: styleCenter },
    I1: { v: '备注', s: styleCenter },
  };
  const baseIndex = 2;
  let nowIndex;
  subDeviceList.map((item, index) => {
    nowIndex = baseIndex + index;
    sheetData = Object.assign(sheetData, {
      [`A${nowIndex}`]: {v: item.addr || '', s: styleCenter},
      [`B${nowIndex}`]: {v: item.deviceName || '', s: styleCenter},
      [`C${nowIndex}`]: {v: item.deviceModel || '', s: styleCenter},
      [`D${nowIndex}`]: {v: item.deviceNo || '', s: styleCenter},
      [`E${nowIndex}`]: {v: item.productionDate || '', s: styleCenter},
      [`F${nowIndex}`]: {v: item.softwareVersion || '', s: styleCenter},
      [`F${nowIndex}`]: {v: item.softwareVersion || '', s: styleCenter},
      [`G${nowIndex}`]: {v: item.deviceSerialNo || '', s: styleCenter},
      [`H${nowIndex}`]: {v: item.statusVal || '', s: styleCenter},
      [`I${nowIndex}`]: {v: item.comment || '', s: styleCenter},
    });
  });
  sheetData['!ref'] = `A1:H${baseIndex + subDeviceList.length - 1}`;
  sheetData["!cols"] = [{
    wch: 15, // 单元格列的宽度
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  },{
    wch: 15,
  }, {
    wch: 15,
  },{
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 25,
  }];
  const sheetName = 'Sheet1';
  const wb = { SheetNames: [`${sheetName}`], Sheets: {} };
  wb.Sheets[`${sheetName}`] = sheetData;
  const nowDay = moment.utc().local().format('YYYY_MM_DD');
  XLSX.writeFile(wb, `组件列表_${nowDay}.xlsx`);
}

export default exportSubDeviceXlsx;
